import { useCallback, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import hubLayout from 'styles/css/hubLayout.module.css';
import { SubUser } from 'type/type';
import { useModal } from 'components/common/ModalLayout';
import { editSubUserFirst, encryptSHA256, getSubUserById } from 'api/api';
import { SubUserLoginInfoContext } from 'pages/Layout';
import Loading from 'components/common/Loading';
import { PwCheckInputField, PwInputField } from 'components/common/InputField';
import { logout } from 'api/bridgeUser';

function FirstLogin() {
  const { subUserLoginInfo } = useContext(SubUserLoginInfoContext);
  const { showModal } = useModal();
  const [loading, setLoading] = useState(false);
  const [subUser, setSubUser] = useState<SubUser>(Object);

  // useForm
  const { register, reset, trigger, formState: { errors, isValid } } = useForm<any>({
    mode: 'all',
  });


  const getSubUser = useCallback(async () => {
    if (!subUserLoginInfo) {
      return showModal("alert", '잘못된 접근입니다.', { confirm: true, cancel: true },
        logout,
        logout,
      );
    }
    setLoading(true);
    try {
      const subUserRes = await getSubUserById(subUserLoginInfo.id);
      if (subUserRes.code === 200) {
        setSubUser(subUserRes.data);
        reset(subUserRes.data);
      } else {
        showModal("alert", subUserRes.message, { confirm: true, cancel: true },
          logout,
          logout,
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [subUserLoginInfo]);

  const _editSubUser = async () => {
    if (!isValid) {
      showModal('alert', '비밀번호를 입력해 주세요.');
      await trigger();
      return;
    }
  
    setLoading(true);
  
    const originalPassword = subUser.password;
    const encryptedPassword = originalPassword ? encryptSHA256(originalPassword) : undefined;
    const requestData = {
      ...subUser,
      password: encryptedPassword,
    };
  
    try {
      const subUserRes = await editSubUserFirst(requestData);
  
      switch (subUserRes.code) {
        case 200:
          showModal( 'alert', `수정이 완료되었습니다. 다시 로그인 후 이용해주세요.`, { confirm: true, cancel: true },
            logout,
            logout
          );
          break;
        default:
          showModal('alert', subUserRes.message);
          break;
      }
    } catch (error) {
      console.error(error);
    } finally {
      // 되돌릴 필요가 있는 경우만 패스워드 복원
      subUser.password = originalPassword;
      setLoading(false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    
    // subUser 상태 업데이트
    setSubUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  useEffect(() => {
    getSubUser();
  }, [getSubUser]);

  useEffect(() => {
    const handleResize = () => {
      window.scrollTo(0, document.body.scrollHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      {loading ? <Loading /> :
        <div className={`${hubLayout.cnt_box}`} >
          <div className={`${hubLayout.acc__cnt}`}>
            <h2 className={`${hubLayout.cnt_title} ${hubLayout.tx_blue}`}>최초 비밀번호 변경</h2>
            <ul className={`${hubLayout.inp_list}`}>
              <li className={`${hubLayout.inp_set} ${hubLayout.label_text}`}>
                <label className={`${hubLayout.imp}`}>이름</label>
                <input type='text' placeholder='한글, 영문 숫자 2~20자' defaultValue={subUser.name} readOnly
                  {...register(`name`, {
                    onChange: handleChange
                  })}
                />
              </li>
              <li className={`${hubLayout.inp_set} ${hubLayout.label_text}`}>
                <label className={`${hubLayout.imp}`}>ID</label>
                <input type='text' placeholder='영문, 숫자 4~20자' defaultValue={subUser.id} readOnly
                  {...register(`id`, {
                    onChange: handleChange
                  })}
                />
              </li>
              <PwInputField value={subUser} register={register} registerOptions={{ required: true, onChange: handleChange }} errors={errors} />
              <PwCheckInputField value={subUser} register={register} registerOptions={{ required: true, onChange: handleChange }} errors={errors} />
            </ul>
            <div className={`${hubLayout.btn_group} ${hubLayout.fixed_bottom_title} ${hubLayout.back_white}`}>
              <button
                type="button"
                className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`}
                onClick={_editSubUser}
              >
                수정
              </button>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default FirstLogin;